import React from 'react'
import clsx from 'clsx'

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'elevated' | 'interactive' | 'premium'
  padding?: 'none' | 'sm' | 'md' | 'lg' | 'xl'
  border?: boolean
  hover?: boolean
  children: React.ReactNode
}

export const Card: React.FC<CardProps> = ({
  variant = 'default',
  padding = 'md',
  border = true,
  hover = false,
  className,
  children,
  ...props
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
    xl: 'p-8',
  }

  const variantClasses = {
    default: 'bg-[var(--bg-card)]',
    elevated: 'bg-[var(--bg-elevated)] shadow-[var(--shadow-md)]',
    interactive: 'bg-[var(--bg-card)] cursor-pointer',
    premium: 'bg-[var(--bg-card)] shadow-[var(--shadow-sm)] relative',
  }

  const isPremium = variant === 'premium'

  return (
    <div
      className={clsx(
        'rounded-[var(--radius-xl)]',
        variantClasses[variant],
        paddingClasses[padding],
        border && 'border border-[var(--border)]',
        hover && 'transition-all duration-300 hover:shadow-[var(--shadow-lg),var(--shadow-glow)] hover:border-[var(--border-accent)] hover:translate-y-[-2px]',
        isPremium && 'overflow-hidden',
        className
      )}
      {...props}
    >
      {/* Premium gold accent line */}
      {isPremium && (
        <div
          className="absolute top-0 left-6 right-6 h-[1px] opacity-0 transition-opacity duration-300 group-hover:opacity-100"
          style={{ background: 'linear-gradient(90deg, transparent, rgba(var(--accent-glow-rgba), 0.3), transparent)' }}
          aria-hidden
        />
      )}
      {children}
    </div>
  )
}

export default Card